/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useToggle from 'academy-common-lib/hooks/useToggle';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { useCallback } from 'react';
import { refetchAssignments, useDeletePlaylistAssignment, usePlaylistAssignments } from '../playlistAssignmentsQueries';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import I18n from 'I18n';
import UsageTracker from '../../../utils/UsageTracker';
import { usePlaylistAssignmentsParams } from '../playlistAssignmentsHooks';
import { useUserInfo } from '../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const UnAssignPlaylistButton = ({
  assignments,
  children = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.common.unassignAll"
  }),
  onDeleted,
  onClick,
  render = ({
    handleOnClick
  }) => /*#__PURE__*/_jsxs(UIButton, {
    onClick: handleOnClick,
    use: "link",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "delete"
    }), children]
  })
}) => {
  const {
    isShowing,
    show,
    hide
  } = useToggle();
  const {
    userInfo,
    userInfoLoading
  } = useUserInfo();
  const {
    playlistId,
    portalId
  } = usePlaylistAssignmentsParams();
  const {
    playlistAssignments,
    playlistAssignmentsLoading
  } = usePlaylistAssignments({
    playlistId,
    portalId,
    assignmentIds: assignments
  });
  const {
    deletePlaylistAssignment,
    deletePlaylistAssignmentLoading
  } = useDeletePlaylistAssignment();
  const handleDelete = useCallback(async () => {
    const deletedSelf = (playlistAssignments || []).find(assignment => {
      return userInfo && userInfo.user.id === assignment.assignee.userId;
    }) !== undefined;
    const numberOfAssignmentsDeleted = assignments.length;
    await Promise.all(assignments.map(async assignmentId => await deletePlaylistAssignment({
      assignmentId
    }))).then(async () => {
      await refetchAssignments();
      UsageTracker.track('playlistInteraction', {
        action: 'playlist-unassigned',
        assignee: deletedSelf,
        numberOfSelected: numberOfAssignmentsDeleted
      });
    }).catch(() => {
      FloatingAlertStore.addAlert({
        message: I18n.text('learningCenter.playlists.unassignUsersErrorMessage'),
        titleText: I18n.text('learningCenter.playlists.unassignUsersErrorTitle'),
        type: 'danger'
      });
    }).finally(() => {
      hide();
      if (onDeleted) {
        onDeleted();
      }
    });
  }, [assignments, deletePlaylistAssignment, hide, onDeleted, playlistAssignments, userInfo]);
  const handleOnClick = e => {
    show();
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [render({
      handleOnClick
    }), isShowing && /*#__PURE__*/_jsxs(UIModal, {
      use: "success",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignUser"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: hide
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignExplanationOne"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignExplanationTwo"
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          disabled: deletePlaylistAssignmentLoading || playlistAssignmentsLoading || userInfoLoading,
          onClick: handleDelete,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.unassignUser"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          disabled: deletePlaylistAssignmentLoading,
          onClick: hide,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.common.cancel"
          })
        })]
      })]
    })]
  });
};